import { render, staticRenderFns } from "./sddjl.vue?vue&type=template&id=51547cf8&scoped=true"
import script from "./sddjl.vue?vue&type=script&lang=js"
export * from "./sddjl.vue?vue&type=script&lang=js"
import style0 from "./sddjl.vue?vue&type=style&index=0&id=51547cf8&prod&lang=less"
import style1 from "./sddjl.vue?vue&type=style&index=1&id=51547cf8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51547cf8",
  null
  
)

export default component.exports